import React, { useContext, useEffect, useState } from "react";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { AppContext } from "../../../App";
import MaterialPagination from "../../styles/materialPagination";
import { TransferContainerContext } from "./TransferContainer";
import { useHistory } from "react-router-dom";
import TransferList from "./TransferList";
import { HTTP_STATUSES, TRANSFER_USER } from "../../../utils/consts";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import TransferFilter from "../../elements/transfer/client/TransferFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";

const TransferPaymentContainer = ({ refetch, setRefetch }) => {

  const history = useHistory();

  const { notification, setNotification } = useContext(TransferContainerContext);
  const { user } = useContext(AppContext);

  const [totalPageCount, setTotalPageCount] = useState(null);
  const [transfersPayment, setTransfersPayment] = useState(null);

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "payment-transfers", false, true),
    "id": checkFilterItem(history, "id", null),
    "note": checkFilterItem(history, "note", null),
    "receiver.email": checkFilterItem(history, "receiver.email", null),
    "currency.asset": checkFilterItem(history, "currency.asset", null),
    "service.name": checkFilterItem(history, "service.name", null),
    "status": checkFilterItem(history, "status", null),
    "createdAt[gte]": checkFilterItem(history, "createdAt[gte]", null, true),
    "createdAt[lte]": checkFilterItem(history, "createdAt[lte]", null, true),
    "updatedAt[gte]": checkFilterItem(history, "updatedAt[gte]", null, true),
    "updatedAt[lte]": checkFilterItem(history, "updatedAt[lte]", null, true)
  });

  const clearFilterData = () => {
    let clearFilterData = { "page": 1 };

    if (filterData["currentTab"]) {
      clearFilterData.currentTab = filterData["currentTab"];
    }

    setFilterData(clearFilterData);
  };

  const fetchTransfersPaymentListForUser = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get(
      `/api/get-transfer-native${filterUrl}&receiver.id=${user.userId}`, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setTransfersPayment(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).
      catch(error => {
        setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
      });
  };

  const processBadgeCounter = () => {
    axios.post("/api/transfers/set-viewed", {}, userAuthenticationConfig());
  }

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  useEffect(() => {
    processBadgeCounter();
  }, []);

  useEffect(() => {
    fetchTransfersPaymentListForUser();
  }, [filterData, refetch]);

  return (
    <>
      <div className="transfer-head">
        <TransferFilter
          filterData={filterData}
          setFilterData={setFilterData}
          userId={user.userId}
          direction={TRANSFER_USER.RECEIVER}
        />
        <ItemsPerPageSelect
          itemsPerPage={filterData.itemsPerPage}
          setItemsPerPage={(data) => setFilterData({
            ...filterData,
            "itemsPerPage": data,
            page: 1
          })}
        />
      </div>
      <FilterAppliedList
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <TransferList
        transfers={transfersPayment}
        action={TRANSFER_USER.RECEIVER}
        setRefetch={setRefetch}
        refetch={refetch}
      />
      {totalPageCount > 0 &&
        <MaterialPagination
          count={totalPageCount}
          shape="rounded"
          page={filterData.page}
          onChange={(event, page) => onChangePage(event, page)}
        />}
    </>
  );
};

export default TransferPaymentContainer;